import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Fade,
  Modal,
  Stack,
  Typography,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

export default function ConfirmDeleteClosureModal({
  open,
  closure,
  deleting,
  onCancel,
  onConfirm,
}) {
  return (
    <Modal
      open={open}
      onClose={deleting ? undefined : onCancel}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{ backdrop: { timeout: 300 } }}
    >
      <Fade in={open}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "90%", sm: 440 },
            bgcolor: "neutral.50",
            borderRadius: "24px",
            boxShadow: 24,
            p: 3,
            outline: "none",
            border: "2px solid",
            borderColor: "primary.900",
          }}
        >
          <Stack spacing={2} alignItems="center" textAlign="center">
            <Box sx={{ bgcolor: "#fff3e0", p: 1.6, borderRadius: "50%" }}>
              <WarningAmberIcon sx={{ fontSize: 42, color: "#f57c00" }} />
            </Box>

            <Typography sx={{ fontSize: 20, fontWeight: 900, color: "primary.900" }}>
              Eliminar cierre en trabajo
            </Typography>

            <Typography sx={{ fontSize: 14.5, color: "neutral.700", lineHeight: 1.45 }}>
              Esta acción eliminará lógicamente el cierre seleccionado. Si el backend
              rechaza la operación, el cierre en trabajo seguirá visible.
            </Typography>

            <Typography sx={{ fontSize: 13, fontWeight: 800, color: "primary.900" }}>
              {closure?.name || "Cierre seleccionado"}
            </Typography>

            <Stack direction="row" spacing={2} sx={{ width: "100%", pt: 1 }}>
              <Button
                fullWidth
                disabled={deleting}
                onClick={onCancel}
                sx={{
                  bgcolor: "#ffcdd2",
                  color: "primary.900",
                  py: 1.1,
                  borderRadius: "24px",
                  border: "2px solid",
                  textTransform: "none",
                  fontWeight: 800,
                  "&:hover": { bgcolor: "#ffb3ba" },
                }}
              >
                Cancelar
              </Button>

              <Button
                fullWidth
                disabled={deleting}
                onClick={onConfirm}
                sx={{
                  bgcolor: "#ffe082",
                  color: "primary.900",
                  py: 1.1,
                  borderRadius: "24px",
                  border: "2px solid",
                  textTransform: "none",
                  fontWeight: 800,
                  "&:hover": { bgcolor: "#ffd54f" },
                }}
              >
                {deleting ? <CircularProgress size={22} color="inherit" /> : "Eliminar"}
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Fade>
    </Modal>
  );
}
